// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1fvgI","left":"styles_left__1tvLh","desktopActions":"styles_desktopActions__3q6b4","title":"styles_title__2gHVe"};